import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      id: 1,
      icon: 'Shield',
      label: 'SSL Encrypted',
      color: 'var(--color-success)'
    },
    {
      id: 2,
      icon: 'Lock',
      label: 'Bank-Level Security',
      color: 'var(--color-primary)'
    },
    {
      id: 3,
      icon: 'CheckCircle2',
      label: 'SOC 2 Compliant',
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
      {badges?.map((badge) => (
        <div
          key={badge?.id}
          className="flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 rounded-[8px] bg-muted/30 hover:bg-muted/50 transition-smooth"
        >
          <Icon name={badge?.icon} size={16} color={badge?.color} />
          <span className="text-xs md:text-sm font-medium text-muted-foreground caption">
            {badge?.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;